import type { ReactNode } from 'react';
import { useContext } from 'react';

import { nanoid } from 'nanoid'

import { RadioStyled } from './styles/RadioStyled'
import { RadioGroupContext } from '../../RadioGroupContext'
import { Space } from '@ui/elements/Space'
import { SubText } from '@ui/elements/Text'

export interface IRadioProps {
  value: string
  label: string
  isDisabled?: boolean
  description?: string | ReactNode
}

export const Radio = ({
  label,
  value: radioValue,
  isDisabled = false,
  description = null,
}: IRadioProps) => {
  const labelId = `id-${nanoid()}-label`

  const { name, value, onChange } = useContext(RadioGroupContext)

  const descriptionContent =
    typeof description === 'string' ? (
      <SubText>{description}</SubText>
    ) : (
      description
    )

  return (
    <RadioStyled isDisabled={isDisabled}>
      <Space direction='horizontal' size='small'>
        <input
          type='radio'
          name={name}
          aria-labelledby={labelId}
          checked={value === radioValue}
          value={radioValue}
          onChange={onChange}
          disabled={isDisabled}
        />

        <>
          <SubText id={labelId} bold autoMargin={false}>
            {label}
          </SubText>

          {!!description && descriptionContent}
        </>
      </Space>
    </RadioStyled>
  )
}
